// extracted by mini-css-extract-plugin
export default {"paginationContainer":"RmAAd"};